import { feederProductLabel, subscriptionStatusLabel, usePortalLanguage } from "./virtualFarmerI18n"

export const serviceBillingState = (subscription, now = new Date()) => {
     const billing = subscription?.paymentsEnabled === false ? "disabled"
          : subscription?.paymentsEnabled === true ? "enabled" : "unknown"
     if (billing !== "enabled") return { billing, renewal: null, renewalDate: null }
     const date = subscription?.renewsOn
     const parsed = typeof date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(date)
          ? new Date(`${date}T00:00:00Z`) : null
     if (!parsed || !Number.isFinite(parsed.getTime()) || parsed.toISOString().slice(0, 10) !== date) {
          return { billing, renewal: "unknown", renewalDate: null }
     }
     // The API supplies a calendar date, not a payment execution timestamp.
     return { billing, renewal: date < now.toISOString().slice(0, 10) ? "past" : "recorded", renewalDate: parsed }
}

export default function ServicePlanCard({ subscription }) {
     const { locale, t } = usePortalLanguage()
     const state = serviceBillingState(subscription)
     return <article className="vf-card vf-plan-card" data-testid="service-plan">
          <span className={`vf-connection ${subscription?.status === "active" ? "connected" : "suspended"}`}>
               {subscriptionStatusLabel(subscription?.status, subscription?.statusLabel, t)}
          </span>
          <h3>{feederProductLabel(subscription?.planName) || "FEEDER"}</h3>
          <strong>{state.billing === "enabled"
               ? subscription?.monthlyPriceLabel || t("service.priceUnknown")
               : t(`service.billing.${state.billing}`)}</strong>
          <p>{t("service.planText")}</p>
          <p>{t(`service.billingText.${state.billing}`)}</p>
          {state.billing === "enabled" && <div className="vf-plan-footer">
               <span>{t(`service.renewal.${state.renewal}`)}</span>
               <b>{state.renewalDate
                    ? new Intl.DateTimeFormat(locale, { day: "numeric", month: "long", year: "numeric", timeZone: "UTC" }).format(state.renewalDate)
                    : t("service.dateUnknown")}</b>
          </div>}
     </article>
}
